import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Table,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import ToastApp from "../../../ToastApp";
import { useTranslation } from "react-i18next";
import api from "../../../utils/Url";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { Navigate, useLocation, useNavigate } from "react-router-dom";


type Props = {};

interface FileOption {
  value: number;
  fileName: string;
  fileNo?: string;
  synopsis: string;
  remark: string;
  totalPages: string;
  rfid: string;
  chackNo: string;
}

const FileMovement = (props: Props) => {
  const back = useNavigate();


  const { i18n, t } = useTranslation();
  //Member Detail Section
  const [memberName, setMemberName] = useState("");
  const [memberGroup, setMemberGroup] = useState("");
  const [department, setDepartment] = useState("");
  const [issuesLimit, setIssuesLimit] = useState("");
  const [courseDesignation, setCourseDesignation] = useState("");
  const [alreadyIssued, setAlreadyIssued] = useState("");
  const [issueDays, setIssueDays] = useState("");
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  const [memberOption, setMemberOption] = useState<any>("");
  const [antina, setAntina] = useState<any>(0);

  const [epcNumber, setEPCNumber] = useState<any>("");
  const [fileDetails, setFileDetails] = useState<FileOption[] | any>([]);
  const [fileDetailsTableData, setFileDetailsTableData] = useState<any>([]);
  const [throughyby, setThroughby] = useState("");
  //FileDetails Tran section
  const [chakno, setChakNo] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileNo, setFileNo] = useState("");
  const [remark, setRemark] = useState("");
  const [rfid, setRFID] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [totalPages, setTotalPages] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const [LocationOption, setLocationOption] = useState<any>([
    { value: "-1", label: "Select To Location" },
  ]);

  const [receiverName, setReceiverName] = useState("");
  const [senderName, setSenderName] = useState("");
  const [selectedLocationLabel, setSelectedLocationLabel] = useState('');
  const [fileIDs, setFileID] = useState("");

  const [senderOptions, setSenderOptions] = useState<any>([]);
  const [receiverOptions, setReceiverOptions] = useState<any>([]);

  const [isDefaultValueSet, setIsDefaultValueSet] = useState(false);

  if (!isDefaultValueSet) {
    const defaultLocation = LocationOption.find(
      (option: any) => option.value === parseInt(synopsis)
    );

    if (defaultLocation) {
      setSelectedLocationLabel(defaultLocation.label);
      setIsDefaultValueSet(true);
    }
  }




  useEffect(() => {
    fetchMemberData();
    fetchRecevierMemberData();
    getFileDtailsData();
    getLocation();
  }, []);

  const getLocation = () => {
    const collectData = {
      id: -1,
    };
    api
      .post( `LocationItems/GetMappedLocation`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.location,
          value: item.id,
        }));
        setLocationOption(arr);
      });
  };


  

  const getFileDtailsData = async () => {
    const collectData = {
      fileID: -1,
      fileType: -1,
      fileGroup: -1,
      fileCategory: -1,
      fileClass: -1,
      fileSubject: -1,
      show: true,
      exportOption: "",
    };
    const response = await api.post(
       `FileDetail/GetFileDetails`,
      collectData
    );
    const arr: FileOption[] = response?.data?.data?.map((item: any) => ({
      value: item.fileID,
      fileName: item.fileName,
      fileNo: item.fileNo,
      currentLocation: item.currentLocation,
      remark: item.remark,
      totalPages: item.totalPages,
      rfid: item.rfid,
      chackNo: item.chackNo,
    }));

    setFileDetails(arr);
  };

  const fetchMemberData = () => {
    const collectData = {
      useR_ID:"-1"
    };
    api
      .post( `USER/GetUSER`, collectData)
      .then((response) => {
        const arr = response.data.data.map((item: any) => ({
          label: item.firsT_NAME,
          value: item.useR_ID,
        }));
        setMemberOption(arr);
        setSenderOptions(arr);
        // setReceiverOptions(arr);
      });
  };

  let ID: any = localStorage.getItem("useR_ID")
  if (ID !== null) {
    ID = ID.replace(/\D/g, '');
    // console.log("useR_ID", parseInt(ID));
  } else {
    toast.error("User ID not Found");
  }

  const fetchRecevierMemberData = () => {
    const collectData = {
      useR_ID:(ID),
    };
    api
      .post( `USER/GetSelectedUSER`, collectData)
      .then((response) => {
        const arr = response.data.data.map((item: any) => ({
          label: item.firsT_NAME,
          value: item.useR_ID,
        }));
        setMemberOption(arr);
        setReceiverOptions(arr);
      });
  };

  const handleSenderChange = (event:any, newValue:any) => {
    const selectedId = newValue ? newValue?.value : '';
    setReceiverOptions(memberOption.filter((option:any) => option?.value !== selectedId));
    setSenderName(selectedId);
  };

  const handleReceiverChange = (event:any, newValue:any) => {
    const selectedId = newValue ? newValue?.value : '';
    setReceiverName(selectedId);
    setSenderOptions(memberOption.filter((option:any) => option?.value !== selectedId));
  };

  const addRow = () => {

    if (!fileDetails ) {
      toast.error("Please  file details before adding a new row.");
      return;
  }

    const existingRow = fileDetailsTableData.find((row: any) => row.fileName === fileName && row.fileNo === fileNo && row.chakno === chakno && row.rfid === rfid);

    if (existingRow) {
      // If the entry already exists, show an alert message
      alert("This entry already exists.");
      return;
    }

    const newRow = {
      id: fileDetailsTableData.length + 1,
      fileName: fileName,
      fileNo: fileNo,
      chakno: chakno,
      rfid: rfid,
      synopsis: selectedLocationLabel,
      totalPages: totalPages,
      remark: remark,
      throughyby:throughyby
    };
    setFileDetailsTableData((prevTableData: any) => {
      const updatedTableData = [...prevTableData, newRow];
      console.log(newRow);
      return updatedTableData;
    });

    // setFileDetails("");
    setChakNo("");
    setFileName("");
    // setFileNo("");
    setRemark("");
    setRFID("");
    setSynopsis("");
    // setTotalPages("");
  };

  const handleSubmit = async () => {
    const collectData = {
      "hid": -1,
      "fileID": fileIDs,
      "fileNumber": fileNo,
      "fileDate": "2024-04-29T08:23:40.077Z",
      "fromLocation": selectedLocationLabel,
      "toLocation": "",
      "sender": senderName,
      "receiver": receiverName,
      "createdDate": "2024-04-29T08:23:40.077Z",
      "createdBy": "",
      "throughBy": throughyby,
    }
    console.log("check value", collectData)
    const response = await api.post(
       `FileMovementHistory/AddUpdateFileMovementHistory`,
      collectData
    );

    if (response.data.isSuccess) {
      toast.success("File Movement : ",response.data.mesg);
      window.location.reload();
      setSenderName("");
      setReceiverName("");
      setFileID("");
      setFileNo("");
      setThroughby("");
      setSelectedLocationLabel("");
    } else {
      toast.error(response.data.mesg);
    }

  }

  return (
    <div
      style={{
        padding: "-5px 5px",
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        marginTop: "3vh",
        // border: ".5px solid #FF7722",
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          textAlign="center"
          style={{ fontSize: "18px", fontWeight: 500, marginBottom: "5px" }}
        >
          {t("text.FileMovement")}
        </Typography>

        <Divider />
        <Grid item sm={4} xs={12} >
            <Typography style={{ marginTop: '-75px', marginBottom:"10px" }}>
              <Button type='submit' onClick={() => back(-1)} variant='contained' style={{ marginBottom: 15, marginTop: '45px', backgroundColor: 'blue', width: 20 }}><ArrowBackSharpIcon /></Button>
            </Typography>
          </Grid>
        <br />

        <form>
          <Grid item xs={12} sm={12} container spacing={2}>
            

            <Grid item xs={12} sm={12} container spacing={4}>
              {/* Member */}
              <Grid item lg={3} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  fullWidth
                  size="small"
                  options={senderOptions}
                   onChange={handleSenderChange}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectSenderMember")} />
                  )}
                />
              </Grid>

              <Grid item lg={3} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={receiverOptions}
                  fullWidth
                  size="small"
                  onChange={handleReceiverChange}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectReceiverMember")} />
                  )}
                />
              </Grid>


             
              <Grid xs={12} lg={3} sm={3} item style={{ marginBottom: "10px" }}>
                <Autocomplete
                  disablePortal
                  options={fileDetails}
                  getOptionLabel={(option: any) => option.fileName}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    if (newValue) {
                      console.log("Selected value:", newValue);
                      setFileID(newValue?.value);
                      setChakNo(newValue?.chackNo);
                      setFileName(newValue?.fileName);
                      setFileNo(newValue?.fileNo);
                      setRemark(newValue?.remark);
                      setRFID(newValue?.rfid);
                      setSynopsis(newValue?.currentLocation);
                      setTotalPages(newValue?.totalPages);
                      console.log("Selected value syno:", synopsis);

                    } else {
                      setChakNo("");
                      setFileName("");
                      setFileNo("");
                      setRemark("");
                      setRFID("");
                      setSynopsis("");
                      setTotalPages("");
                    }
                  }}
                  renderInput={(params:any) => (
                    <TextField {...params} label={t("text.selectfiledetails")} />
                  )}
                />
              </Grid>

              <Grid lg={3} sm={3} xs={12} item>
                <TextField
                  label={
                    <span>
                      {t("text.ethroughyby")}
                    </span>
                  }
                  value={throughyby}
                  placeholder={t("text.ethroughyby")}
                  size="small"
                  fullWidth
                  name="throughyby"
                  id="throughyby"
                  style={{ backgroundColor: "white" }}
                  onChange={(event:any)=>{
                    setThroughby(event.target.value)
                  }}
                />
              </Grid>
{/* 
              <Grid item xs={2}>
                <Button
                  // fullWidth
                  style={{
                    backgroundColor: "#4990E2",
                    color: "white",
                    marginBottom: "10px",
                  }}
                  onClick={addRow}
                >
                  <AddCircleOutlineIcon />{" "} {t("text.Add")}
                </Button>
              </Grid> */}

              {/* <Grid container xs={12} spacing={2}>
                <Grid xs={12} sm={12} item>
                  <Table
                    style={{
                      borderCollapse: "collapse",
                      width: "97%",
                      border: "1px solid black",
                      marginLeft: "30px",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: "#2196f3",
                        color: "#f5f5f5",
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingBlock: "10",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.FileName")}
                        </th>

                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.FileNo")}
                        </th>
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                         {t("text.ChackNo")}
                        </th>
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.RFID")}
                        </th>
                        
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.throughyby")}
                        </th>
                        
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.Remark")}
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ border: "1px solid black" }}>
                      {fileDetailsTableData.map(
                        (row: any, index: any) => (
                          <tr
                            key={row.id}
                            style={{ border: "1px solid black" }}
                          >
                            <td
                              style={{
                                borderLeft: "1px solid black",
                                borderTop: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                                {row.fileName}
                            </td>

                            <td
                              style={{
                                borderLeft: "1px solid black",
                                borderTop: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                                {row.fileNo}
                            </td>

                            <td
                              style={{
                                borderLeft: "1px solid black",
                                borderTop: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                             {row.chakno}
                            </td>

                            <td
                              style={{
                                borderLeft: "1px solid black",
                                borderTop: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {row.rfid}
                            </td>
                            
                            <td
                              style={{
                                borderLeft: "1px solid black",
                                borderTop: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {row.throughyby}
                            </td>
                            
                            <td
                              style={{
                                borderLeft: "1px solid black",
                                borderTop: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {row.remark}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </Grid>
              </Grid> */}

              <Grid container item xs={12} >
                <Button
                  fullWidth
                  style={{
                    backgroundColor: "#4990E2",
                    color: "white",
                    marginBottom: "10px",
                    marginRight: "10px",
                    marginLeft: "10px",
                    width: "47%"
                  }}
                  onClick={(e) => handleSubmit()}
                >
                 {t("text.save")}
                </Button>
                <Button

                  style={{
                    backgroundColor: "#059669",
                    color: "white",
                    marginBottom: "10px",
                    width: "47%"

                  }}

                >
                  {t("text.reset")}
                </Button>
              </Grid>

              <br />
            </Grid>
          </Grid>
        </form>
      </CardContent>
      <ToastApp />
    </div>
  );
};

export default FileMovement;